<script lang="ts">
import { RouterView } from 'vue-router';
import AsideMenu from './main/menu.vue';
import { fetchUserSections } from '@/api/admin-be';
import { useAppStore } from '@/stores/app';
import { mapState } from 'pinia';
import DesktopMenu from '@/components/menu/desktop-menu.vue';

export default {
  name: 'main-layout',
  components: { DesktopMenu, RouterView, AsideMenu },
  computed: {
    ...mapState(useAppStore, ['token']),
    filteredSections() {
      if (this.sections) {
        return this.sections
          ? this.items.filter(item => this.sections?.includes(item.section))
          : [];
      }
    },
    routeDetails() {
      return this.$router.currentRoute.value;
    }
  },
  data() {
    return {
      items: [
        { label: 'Статус', route: '/', icon: 'pi pi-server', section: 'status' },
        { label: 'Пользователи', route: '/users', icon: 'pi pi-users', section: 'users' },
        { label: 'Статистика', route: '/stakes', icon: 'pi pi-money-bill', section: 'bets' },
        // { label: 'Ставки (по купонам)', route: '/calculator', icon: 'pi pi-percentage', section: 'calculator' },
        { label: 'Ставки', route: '/bets', icon: 'pi pi-percentage', section: 'calculator' },
        { label: 'Профиль игрока', route: '/profile', icon: 'pi pi-user-edit', section: 'bets' },
        { label: 'Приоритеты спорта', route: '/sports', icon: 'pi pi-sort-numeric-up-alt', section: 'priorities' },
        { label: 'Популярные турниры', route: '/popular-competitions', icon: 'pi pi-star-fill', section: 'favorites' },
        { label: 'Популярные матчи', route: '/popular-events', icon: 'pi pi-star-fill', section: 'favorites' },
        { label: 'Переводы', route: '/translations', icon: 'pi pi-book', section: 'translations' },
        { label: 'Лайв-события', route: '/in-progress-events', icon: 'pi pi-stopwatch', section: 'inprogress' },
        { label: 'Детали событий', route: '/event', icon: 'pi pi-stopwatch', section: 'inprogress' },
        // { label: 'Тотализаторы', route: '/pools', icon: 'pi pi-trophy', section: 'pools' },
        { label: 'Тото', route: '/toto', icon: 'pi pi-trophy', section: 'pools' },
      ],
      sections: null as null | string[],
    };
  },
  mounted() {
    if (this.token) {
      this.$nextTick(() => {
        fetchUserSections().then((sections) => {
          this.sections = sections;
        });
      });
    }
  },
};
</script>

<template>
  <div class="p-2">
    <img src="/logo.svg" alt="CG"/>
  </div>
  <div id="title" />
  <aside class="z-20">
    <desktop-menu :items="filteredSections"/>
  </aside>
  <div>
    <RouterView />
  </div>
</template>
